import { isSecurityCodeValid } from 'creditcard.js';

class CardVerificationValue {
  constructor(value, number) {
    this.value = value;
    this.number = number;
  }
  static build(value, number) {
    return new CardVerificationValue(value, number);
  }
  isValid() {
    return isSecurityCodeValid(this.number, this.value);
  }
  getValue() {
    return this.value;
  }
}

export { CardVerificationValue };
